<template>
  <div>
    <div class="container">
      <div
        class="header-box"
        style="width: 100%;display: flex;justify-content: space-between;align-items: center;"
      >
        <el-form :inline="true" :model="formInline">
          <el-form-item label="渠道">
            <el-select
              v-model="formInline.sort_type"
              @change="selectChange(2, $event)"
            >
              <el-option
                v-for="item in sort_type"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="会员类型">
            <el-select
              v-model="formInline.vip_id"
              @change="selectChange(1, $event)"
            >
              <el-option
                v-for="item in vip_type"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <el-table
        :data="tableData"
        border
        class="table"
        row-key="id"
        ref="multipleTable"
        v-show="isSortShow"
        header-cell-class-name="table-header"
        v-loading="loading"
      >
        <el-table-column label="ID" align="center" width="50">
          <template slot-scope="scope">
            {{ scope.row.id }}
          </template>
        </el-table-column>
        <el-table-column prop="title" label="名称" align="center">
        </el-table-column>
        <el-table-column prop="vip.title" label="会员名称" align="center">
        </el-table-column>
        <el-table-column prop="original_price" label="原价" align="center">
        </el-table-column>
        <el-table-column prop="price" label="价格" align="center">
        </el-table-column>
        <el-table-column prop="apple_price" label="IOS价格" align="center">
        </el-table-column>
        <el-table-column prop="days" label="开通天数" align="center">
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" align="center">
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-edit"
              @click="handleEdit(scope.row)"
              >修改</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-table
        :data="tableData"
        border
        class="table"
        v-show="!isSortShow"
        header-cell-class-name="table-header"
        v-loading="loading"
      >
        <el-table-column label="ID" align="center" width="50">
          <template slot-scope="scope">
            {{ scope.row.id }}
          </template>
        </el-table-column>
        <el-table-column prop="title" label="名称" align="center">
        </el-table-column>
        <el-table-column prop="vip.title" label="会员名称" align="center">
        </el-table-column>
        <el-table-column prop="original_price" label="原价" align="center">
        </el-table-column>
        <el-table-column prop="price" label="价格" align="center">
        </el-table-column>
        <el-table-column prop="apple_price" label="IOS价格" align="center">
        </el-table-column>
        <el-table-column prop="days" label="开通天数" align="center">
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" align="center">
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-edit"
              @click="handleEdit(scope.row)"
              >修改</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div>
        <el-button type="primary" style="margin-top: 20px;" @click="editSort()"
          >排序管理</el-button
        >
        <el-button
          v-show="isSortShow"
          type="primary"
          style="margin-top: 20px;"
          @click="saveSortData()"
          >保存排序</el-button
        >
      </div>
    </div>

    <!-- 编辑弹出框 -->
    <el-dialog
      :visible.sync="editVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-form :model="form" label-width="120px">
        <el-form-item label="名称：">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="原价：">
          <el-input v-model="form.original_price"></el-input>
        </el-form-item>
        <el-form-item label="价格：" v-if="this.formInline.sort_type == 0|| this.formInline.sort_type == 2">
          <el-input v-model="form.price"></el-input>
        </el-form-item>
        <el-form-item label="IOS价格：" v-if="this.formInline.sort_type == 1">
          <el-input v-model="form.apple_price"></el-input>
        </el-form-item>
        <el-form-item label="开通天数：">
          <el-input v-model="form.days"></el-input>
        </el-form-item>
        <el-form-item label="简介：">
          <el-input v-model="form.summary"></el-input>
        </el-form-item>
        <el-form-item label="PC(选中)" v-if="this.formInline.sort_type == 2">
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="pcUpload"
          >
            <img
              v-if="form.image_full"
              :src="form.image_full"
              class="avatar"
              alt="暂未上传"
            />
            <em
              v-show="!form.image_full && !uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
        </el-form-item>
        <el-form-item label="PC(未选中)" v-if="this.formInline.sort_type == 2">
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="beforePcUpload"
          >
            <img
              v-if="form.image_unchecked_full"
              :src="form.image_unchecked_full"
              class="avatar"
              alt="暂未上传"
            />
            <em
              v-show="!form.image_unchecked_full && !uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
        </el-form-item>
        <el-form-item label="IOS(选中)" v-if="this.formInline.sort_type == 1">
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="iosUpload"
          >
            <img
              v-if="form.image_ios_full"
              :src="form.image_ios_full"
              class="avatar"
              alt="暂未上传"
            />
            <em
              v-show="!form.image_ios_full && !uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
        </el-form-item>
        <el-form-item label="IOS(未选中)" v-if="this.formInline.sort_type == 1">
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="beforeIosUpload"
          >
            <img
              v-if="form.image_ios_unchecked_full"
              :src="form.image_ios_unchecked_full"
              class="avatar"
              alt="暂未上传"
            />
            <em
              v-show="!form.image_ios_unchecked_full && !uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
        </el-form-item>
        <el-form-item label="android(选中)" v-if="this.formInline.sort_type == 0">
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="androidUpload"
          >
            <img
              v-if="form.image_android_full"
              :src="form.image_android_full"
              class="avatar"
              alt="暂未上传"
            />
            <em
              v-show="!form.image_android_full && !uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
        </el-form-item>
        <el-form-item label="android(未选中)" v-if="this.formInline.sort_type == 0">
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="beforeAndroidUpload"
          >
            <img
              v-if="form.image_android_unchecked_full"
              :src="form.image_android_unchecked_full"
              class="avatar"
              alt="暂未上传"
            />
            <em
              v-show="!form.image_android_unchecked_full && !uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="saveEdit">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import http from "../../../api/gaeaApiConfig";
import http2 from "../../../api/uploadApiConfig";
import Sortable from "sortablejs";
export default {
  name: "Vipmanage",
  data() {
    return {
      isSortShow: false,
      formInline: {
        vip_id: 1,
        sort_type: 0,
      },
      form: {},
      //   sort_type
      sort_type: [
        {
          value: 0,
          label: "安卓",
        },
        {
          value: 1,
          label: "苹果",
        },
        {
          value: 2,
          label: "PC",
        },
      ],
      //   vip_type
      vip_type: [
        {
          value: 1,
          label: "基础会员",
        },
        {
          value: 2,
          label: "学霸会员",
        },
      ],
      sort_id: 0,
      dataArr: [],
      tableData: [],
      loading: false,
      editVisible: false,
      uploading: false,
      id: "",
      ids: [],
    };
  },
  created() {
    this.getData();
  },

  methods: {
    selectChange(type, e) {
      if (type == 1) {
        if (e == 1) {
          this.formInline.vip_id = 1;
          this.getData();
        } else {
          this.formInline.vip_id = 2;
          this.getData();
        }
      } else if (type == 2) {
        if (this.formInline.sort_type == 0) {
          this.sort_id = "sort_android";
          this.getData();
        } else if (this.formInline.sort_type == 1) {
          this.sort_id = "sort_ios";
          this.getData();
        } else if (this.formInline.sort_type == 2) {
          this.sort_id = "sort_pc";
          this.getData();
        }
      }
    },
    // 排序管理
    editSort() {
      this.isSortShow = !this.isSortShow;
    },
    // 保存排序
    saveSortData() {
      this.ids = [];
      for (let i = 0; i < this.dataArr.length; i++) {
        this.ids.push(this.dataArr[i].id);
      }
      let params = {
        vip_id: this.formInline.vip_id,
        sort_type: this.sort_id,
        ids: this.ids.toString(),
      };
      http.put("/admin/vip/card_sort", params).then((res) => {
        if (res.data.status_code == 200) {
          this.$message.success("保存成功");
          this.isSortShow = false;
          this.getData();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 拖拽
    initSortTable() {
      // 获取 el-table
      const tableTag = this.$refs["multipleTable"].$el;
      // 获取 tbody 节点
      const elTbody = tableTag.querySelectorAll(
        ".el-table__body-wrapper > table > tbody"
      )[0];
      // 拖拽排序
      this.sortable = Sortable.create(elTbody, {
        onEnd: (evt) => {
          const tempIndex = this.dataArr.splice(evt.oldIndex, 1)[0];
          this.dataArr.splice(evt.newIndex, 0, tempIndex);
          console.log(this.dataArr, "dataArr");
        },
      });
    },
    getData() {
      let that = this;
      that.loading = true;
      // 排序
      if (that.formInline.sort_type == 0) {
        that.sort_id = "sort_android";
      } else if (that.formInline.sort_type == 1) {
        that.sort_id = "sort_ios";
      } else if (that.formInline.sort_type == 2) {
        that.sort_id = "sort_pc";
      }
      let params = {
        vip_id: that.formInline.vip_id,
        sort_type: that.sort_id,
      };
      http.get("admin/vip/card_list", { params }).then(function(res) {
        that.tableData = res.data.data;
        that.dataArr = res.data.data;
        that.$nextTick(() => {
          that.initSortTable();
        });
        that.loading = false;
      });
    },
    // 编辑操作
    handleEdit(row) {
      this.id = row.id;
      this.editVisible = true;
      this.getDetailInfo();
    },
    getDetailInfo() {
      http.get("admin/vip/card/" + this.id).then((res) => {
        if (res.data.status_code == 200) {
          this.form = res.data.data;
          console.log(this.form, "fff");
        }
      });
    },
    // 保存编辑
    saveEdit() {
      let params = this.form;
      console.log(params, "params");
      http.put("admin/vip/card/" + this.id, params).then((res) => {
        if (res.data.status_code == 200) {
          this.$message.success(`修改成功`);
          this.editVisible = false;
          this.getData();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // PC选中
    pcUpload(file) {
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        var filename = file.name.split(".")[0] + "." + imgType;
        ossData.append("work_path", `vip/image`);
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        // that.$forceUpdate();
        http2.post("/upload", ossData).then(function(res) {
          if (res.data.status_code == 200) {
            that.form.image = `vip/image/` + filename;
            that.form.image_full = URL.createObjectURL(file);
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    // PC未选中
    beforePcUpload(file) {
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        var filename = file.name.split(".")[0] + "." + imgType;
        ossData.append("work_path", `vip/image`);
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        // that.$forceUpdate();
        http2.post("/upload", ossData).then(function(res) {
          if (res.data.status_code == 200) {
            that.form.image_unchecked = `vip/image/` + filename;
            that.form.image_unchecked_full = URL.createObjectURL(file);
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    // IOS选中
    iosUpload(file) {
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        var filename = file.name.split(".")[0] + "." + imgType;
        ossData.append("work_path", `vip/image`);
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        // that.$forceUpdate();
        http2.post("/upload", ossData).then(function(res) {
          if (res.data.status_code == 200) {
            that.form.image_ios = `vip/image/` + filename;
            that.form.image_ios_full = URL.createObjectURL(file);
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    // IOS未选中
    beforeIosUpload(file) {
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        var filename = file.name.split(".")[0] + "." + imgType;
        ossData.append("work_path", `vip/image`);
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        // that.$forceUpdate();
        http2.post("/upload", ossData).then(function(res) {
          if (res.data.status_code == 200) {
            that.form.image_ios_unchecked = `vip/image/` + filename;
            that.form.image_ios_unchecked_full = URL.createObjectURL(file);
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    // android选中
    androidUpload(file) {
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        var filename = file.name.split(".")[0] + "." + imgType;
        ossData.append("work_path", `vip/image`);
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        // that.$forceUpdate();
        http2.post("/upload", ossData).then(function(res) {
          if (res.data.status_code == 200) {
            that.form.image_android = `vip/image/` + filename;
            that.form.image_android_full = URL.createObjectURL(file);
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    // android未选中
    beforeAndroidUpload(file) {
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        var filename = file.name.split(".")[0] + "." + imgType;
        ossData.append("work_path", `vip/image`);
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        // that.$forceUpdate();
        http2.post("/upload", ossData).then(function(res) {
          if (res.data.status_code == 200) {
            that.form.image_android_unchecked = `vip/image/` + filename;
            that.form.image_android_unchecked_full = URL.createObjectURL(file);
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
  },
};
</script>

<style scoped>
.handle-box {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 300px;
  display: inline-block;
}
.table {
  width: 100%;
  font-size: 14px;
}
.red {
  color: #ff0000;
}
.mr10 {
  margin-right: 10px;
}
.table-td-thumb {
  display: block;
  margin: auto;
  width: 180px;
}
.self-dialog-footer {
  display: block;
  text-align: center;
}
.avatar {
  height: 178px;
  display: block;
  max-width: 100%;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
</style>
